export default class Moebius {
  constructor(options, callback, element) {
    this.element = $(element);
    this._create(options, callback);
  }

  _create(options) {
    this.opts = $.extend({}, $.moebius.defaults, options);
    this.state = {
      currPage: 1,
      duringAjax: false,
      nextPage: $(this.opts.pagerNext).attr('href'),
      pixelsToTarget: undefined,
      nextCallBack: undefined,
    };
    this._debug('moebius instance created', this.element);
    this._removePagination();
    this._bindEvents();
  }

  _removePagination() {
    $(this.opts.pagerSelector).remove();
  }

  _bindEvents() {
    const instance = this;

    $(window).smartscroll(function(event) {
      instance._onScroll(event);
    });

    $(document).keydown(function(event) {
      if (event.which == 35) {
        // allows content load when scrolling multiple times using the end key.
        instance.state.pixelsToTarget = Math.random() * 1000;
      }
    });

    this._debug('events set');
  }

  _onScroll() {
    var endLine = this.element.offset().top + this.element.height();
    var currentLine = $(window).scrollTop() + $(window).height();
    var pixelsToTarget = endLine - currentLine;

    if (pixelsToTarget < this.opts.distance) {
      // browsers may snap to last known position on a page when moving
      // through the history, this check prevents content loading without
      // user interaction.
      if (pixelsToTarget !== this.state.pixelsToTarget) {
        this.next();
      }
    }

    this.state.pixelsToTarget = pixelsToTarget;
  }

  _updateHistory() {
    if (this.opts.history && this.opts.history.pushState) {
      this.opts.history.replaceState({}, undefined, this.state.nextPage);
    }
  }

  _debug() {
    if (!this.opts.debug) {
      return;
    }

    if (typeof console !== 'undefined') {
      var args = Array.prototype.slice.call(arguments);
      args.push(this.state);
      /* eslint no-console: "off" */
      console.log.apply(console, args);
    }
  }

  _ajaxSuccess(data) {
    var miniDOM = $('<div/>');
    miniDOM[0].innerHTML = data;
    this._updateHistory();
    this.state.nextPage = miniDOM.find(this.opts.pagerNext).attr('href');
    var elements = miniDOM.find(this.opts.contentElements);
    var that = this;
    elements.each(function() {
      that.element.append(this.outerHTML);
    });
    miniDOM.remove();
    miniDOM = null;
    that = null;

    if (typeof rfqModal != 'undefined'){
      rfqModal.bind();
    } else if (typeof rfqLanding != 'undefined'){
      rfqLanding.bind();
    }

    this._debug('AJAX success');
  }

  _ajaxError() {
    this._debug('AJAX error');
  }

  _ajaxComplete() {
    this.state.duringAjax = false;
    if (typeof this.state.nextCallBack === 'function') {
      this._debug('executing callback');
      this.state.nextCallBack();
    }
    this.state.nextCallBack = undefined;
    this.element.find('.' + this.opts.loaderClass).remove();
    this._trigger('pageLoaded');
  }

  _rcvCommand() {
    var command = arguments[0];
    var args = Array.prototype.splice.call(arguments, 1);

    switch (command) {
      case 'next':
        this.state.nextCallBack = args[0];
        this.next();
        break;

      default:
        this._debug('unknown command', command);
        break;
    }
  }

  _trigger(eventName) {
    this._debug('trigger event', eventName);
    $(window).trigger('moebius.' + eventName);
    $(this).trigger(eventName);
  }

  next() {
    if (this.state.duringAjax || this.state.nextPage === undefined) {
      this._debug('skipping next page event');
      return;
    }

    this.state.duringAjax = true;

    this.element.append(
      '<div class="' +
        this.opts.loaderClass +
        '">' +
        this.opts.loaderContent +
        '</div>'
    );

    this._debug('next fired');

    const instance = this;

    $.ajax({
      type: 'GET',
      url: this.state.nextPage + '?async=0', // no async image load on load more
      cache: true,
      dataType: 'html',
      error: function(jqXHR, status, error) {
        instance._ajaxError(jqXHR, status, error);
      },
      success: function(data, text, jqXHR) {
        instance._ajaxSuccess(data, text, jqXHR);
      },
      complete: function() {
        instance._ajaxComplete();
      },
    });
  }
}
